import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { loadAppSettings } from './config/appSettings';
import { installPageUrlHeader } from './utils/pageUrlHeader';
import { installClientErrorReporter } from './utils/clientErrorReporter';

// Every API call sends X-Page-Url so backend logs show which page it came from.
installPageUrlHeader();

// Every API call sends X-Request-Id; failed calls (+ the toast text shown) are reported to POST /ClientLogs/Error.
installClientErrorReporter();

const root = ReactDOM.createRoot(document.getElementById('root'));

loadAppSettings().finally(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
